import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { ImageReveal } from "../components/ImageReveal";
import { DropHeading } from "./DropHeading";
import { PROPERTIES } from "../properties";

const live = PROPERTIES.filter((p) => p.live);

export const ErthProjects = () => (
  <section id="projects" data-testid="erth-projects" className="bg-erth-white py-20 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 sm:px-8">
      <Reveal className="max-w-2xl">
        <p className="mb-6 font-body text-sm tracking-[0.25em] text-erth-black/50">projects</p>
        <DropHeading
          testId="erth-projects-heading"
          text="escapes, thoughtfully crafted across india"
          className="text-3xl leading-[1.15] text-erth-black sm:text-4xl lg:text-5xl"
        />
      </Reveal>

      {live.map((p) => (
        <div key={p.slug} data-testid={`erth-project-${p.slug}`} className="mt-14 grid items-end gap-8 lg:mt-20 lg:grid-cols-12 lg:gap-14">
          <Link to={`/${p.slug}`} className="group block lg:col-span-8" aria-label={`Open ${p.name}`} data-testid={`erth-project-${p.slug}-image-link`}>
            <ImageReveal src={p.image} alt={p.alt} tone="licorice" className="aspect-[16/10]" />
          </Link>
          <Reveal delay={0.1} className="lg:col-span-4 lg:pb-4">
            <p className="font-body text-sm tracking-[0.22em] text-erth-black/50">{p.location}</p>
            <h3 className="mt-4 font-head text-3xl font-semibold lowercase leading-tight text-erth-black sm:text-4xl">
              {p.name.toLowerCase()} <span className="font-body text-xl font-light text-erth-black/60">{p.subtitle}</span>
            </h3>
            <p className="mt-5 font-body text-base font-light leading-relaxed text-erth-black/75 sm:text-lg">{p.line}</p>
            <Link
              to={`/${p.slug}`}
              data-testid={`erth-project-${p.slug}-link`}
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-erth-black px-8 py-4 font-head text-[14px] font-semibold lowercase text-erth-white transition-colors hover:bg-erth-black/80"
            >
              view project <ArrowUpRight size={16} strokeWidth={2} />
            </Link>
          </Reveal>
        </div>
      ))}
    </div>
  </section>
);
